
























































































































































































































































































































































import Vue from 'vue'

interface IBookInfo {
  name: string;
  faceType: number;
  traitSelected: string;
  materialSelected: number;
  cover: number;
  backgroundSelected: number;
  message: string;
  imagePath: string;
}

export default Vue.extend({
  name: 'PreviewImage',
  props: {
    data: {
      type: Object as () => IBookInfo,
      default: null
    }
  },
  data () {
    return {
      ballonName: this.data.name + (this.data.name.length > 8 ? '　號' : '號'),
      imageLoaded: 0
    }
  },
  mounted () {
    this.getCoverTitlePosition()
  },
  methods: {
    getPath () {
      if (window.screen.width < 360) {
        const ratio = window.screen.width / 360
        console.log('M ' + ratio * 80 + ' ' + ratio * 180 + ' Q ' + 175 * ratio + ' ' + ratio * 130 + ', ' + ratio * 275 + ' ' + 185 * ratio)
        return 'M ' + ratio * 80 + ' ' + ratio * 180 + ' Q ' + 175 * ratio + ' ' + ratio * 130 + ', ' + ratio * 275 + ' ' + 185 * ratio
      } else {
        return 'M 80 180 Q 175 130, 275 185'
      }
    },
    getTraitString () {
      const traitOptions = ['勇敢', '誠實', '健康', '善良', '感恩', '聰明', '樂觀', '勤奮']
      let traitString = ''
      for (let i = 0, j = 0; i < this.data.traitSelected.length; i++) {
        if (this.data.traitSelected.charAt(i) === '1') {
          traitString += traitOptions[i]
          j++
          if (j === 4) {
            break
          } else {
            traitString += '、'
          }
        }
      }
      return traitString
    },
    getSexString (type: number) {
      if (this.data.faceType >= 0 && this.data.faceType <= 2) { // boy
        return type === 1 ? '他' : '男孩'
      } else { // girl
        return type === 1 ? '她' : '女孩'
      }
    },
    getCoverTitlePosition () {
      const div = document.getElementById('cover-title') as HTMLElement
      if (div) {
        div.style.width = '224px'
        switch (this.data.cover) {
          case 0:
          case 1:
            div.style.left = '122px'
            div.style.top = '98px'
            break
          case 3:
            div.style.left = '122px'
            div.style.top = '136px'
            break
          case 2:
          default:
            div.style.left = '122px'
            div.style.top = '106px'
            break
        }
      }
    },
    handleImageLoad () {
      this.imageLoaded++
      if (this.imageLoaded === 13) {
        this.$emit('isLoaded', this.imageLoaded)
      }
    }
  }
})
